import { AdminSignupResponseSchema, SignupFormResponseSchema, UserResponseSchema, type SignupRequest } from '@couch/shared';
import { json } from './client';

/** Open sign-up (doc 64). */
export const signupApi = {
  form: () => json(SignupFormResponseSchema, 'GET', '/auth/signup'),
  signup: (body: SignupRequest) => json(UserResponseSchema, 'POST', '/auth/signup', body),
  adminState: () => json(AdminSignupResponseSchema, 'GET', '/admin/signup'),
  setOpen: (open: boolean) => json(AdminSignupResponseSchema, 'PUT', '/admin/signup', { open }),
};

export const ADMIN_SIGNUP_KEY = ['admin-signup'] as const;
